<div data-cy="auth-patient-auto-login">{{outStr}}</div>
